
/**
 * Javascript file for the page with details on the current event. 
 * @author Adrian Rebmann, Andrea Villeda
 */

import {
    getEventByHash,

} from "../../../../api";
export default {
    name: "EventDetail",
    props: ["hash"],

    /**
     * The vue instance's data object.
     * @property {boolean} loading - Information is currently being processed.
     * @property {object} event - The event item. 
     */
    data() {
        return {
            loading: false,
            event: null
        };
    },

    /**
     * Expressions to be watched.
     */
    watch: {
        $route: "fetchData"
    },

    /**
     * Called after the instance has been created.
     */
    created() {
        this.fetchData();
    },

    /**
     * The vue instance's method declaration.
     */
    methods: {
        /**
         * Returns to the previously visited page.
         */
        goBack() {
            this.$router.go(-1);
        },

        /**
         * Fetches the event by the hash. 
         */
        fetchData() {
            this.event = null;
            this.loading = true;
            getEventByHash(this.hash)
                .then(res => {
                    //console.log(res)
                    this.event = res
                    this.loading = false;
                })
                .catch(err => {
                    //console.log(err);
                    this.loading = false;
                });
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/search/eventsearch/detail/eventdetail.js